import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const errorLogService = {
    getAll,
};

const MODULE = {
    ERROR_LOG: 'error-logs',
};

const API_URL = API.BASE_URL_API + '/v1';

export function getAll(filter) {
    const request = {
        params: {
            context: filter?.context,
            level: filter?.level,
            user: filter?.user,
            page: filter?.pageNumber,
            size: filter?.pageSize,
        },
    };

    let array = filter?.searchArray;
    array?.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`;
            request.params[searchParam] = word;
        }
    });

    return apiHelper(API_URL).get(`/${MODULE.ERROR_LOG}`, request);
}